/**
 * ShoppingAssistant exports
 *
 * IMPORTANT: This file must be SSR-safe!
 * Do NOT import ShoppingAssistantInner or any Constructor packages directly here.
 * Those imports would break SSR due to ESM/CJS compatibility issues.
 *
 * ShoppingAssistantLazy is the entry point used by Header / HeaderV3 (loadable,
 * client-only). ShoppingAssistantInner is dynamically imported only on the client.
 */

// SSR-safe exports - these don't import Constructor packages
export { default as ShoppingAssistantLazy } from './ShoppingAssistantLazy';
export { default as AskPenneyHeaderButton } from './AskPenneyHeaderButton';
export { isAsaEnabled, getAsaCookieName } from './ShoppingAssistant.config';

/**
 * Opens the Ask Penney chat panel by dispatching a custom event.
 * Use this from the header button or any other trigger.
 */
export const openAskPenneyChat = () => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('askpenney:open'));
    }
};

// Default export is the lazy version for SSR safety
export { default } from './ShoppingAssistantLazy';
